import { FC } from 'react'
import {
  List,
  Datagrid,
  TextField,
  TopToolbar,
  CreateButton,
  SearchInput,
  ListProps,
} from 'react-admin'

const filters = [
  <SearchInput source="q" alwaysOn key="q" />,
]

const ListActions = () => (
  <TopToolbar>
    <CreateButton label="Gemeente toevoegen" />
  </TopToolbar>
)

const GemeentenList: FC<ListProps> = (props) => (
  <List
    {...props}
    exporter={false}
    actions={<ListActions />}
    filters={filters}
    sort={{ field: 'naam', order: 'ASC' }}
  >
    <Datagrid bulkActionButtons={false} rowClick="show">
      <TextField source="naam" label="Naam" />
      <TextField source="gm_code" label="Gemeentecode" />
      <TextField source="gm_naam" label="Gemeente" />
      <TextField source="provincie" label="Provincie" />
      <TextField source="corop" label="COROP" />
    </Datagrid>
  </List>
)

export default GemeentenList
